<template>
  <v-card
    class="elevation-5 mb-4 px-2 py-3"
    id="protocolo"
    :class="{ 'print-dark-mode': printDarkMode }"
  >
    <v-container fluid grid-list-md class="ma-0 pa-0">
      <v-layout row wrap>
        <v-flex d-flex lg12>
          <v-layout lg12 row wrap>
            <v-flex d-flex lg8 xs12>
              <h1
                class="grey--text subheading mt-1 pt-2 text--darken-1 text-xs-left "
              >
                Protocolo Nº {{ protocoloDetalhe.numeroProtocolo }}
              </h1>
            </v-flex>
            <v-flex d-flex lg2 xs12 v-if="showBtn">
              <v-btn
                dark
                class="white--text"
                color="primary"
                @click="baixarDetalhesProtocolo"
              >
                Baixar
                <v-icon right>cloud_download</v-icon>
              </v-btn>
            </v-flex>
            <v-flex d-flex lg2 xs12 v-if="showBtn">
              <v-btn light color="grey lighten-2" @click="voltar">Voltar</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider></v-divider>
    <v-container fluid grid-list-md class="ma-0 pa-0">
      <v-layout row wrap>
        <v-flex d-flex lg12>
          <v-expansion-panel expand class="elevation-0 pt-4" v-model="panel">
            <v-expansion-panel-content class="elevation-5 mb-3">
              <template v-slot:header>
                <div class="title">Dados Protocolo</div>
              </template>
              <v-card>
                <v-card-text class="px-4">
                  <v-layout row wrap>
                    <v-flex lg6 xs12>{{
                      protocoloDetalhe.unimedAtendida
                    }}</v-flex>
                    <v-flex lg6 xs12>{{
                      protocoloDetalhe.unimedAtendidaCnpj
                    }}</v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg6 xs12 v-if="protocoloDetalhe.dataAtendimento">
                      Data/Hora de abertura:
                      {{ protocoloDetalhe.dataAtendimento }}
                    </v-flex>
                    <v-flex lg6 xs12 v-if="protocoloDetalhe.canalEntrada">
                      Canal de solicitação: {{ protocoloDetalhe.canalEntrada }}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg6 xs12 v-if="protocoloDetalhe.statusProtocolo">
                      Situação: {{ protocoloDetalhe.statusProtocolo }}
                    </v-flex>
                    <v-flex lg6 xs12>
                      Prazo previsto de resposta:
                      {{ protocoloDetalhe.dataPrazoExterno }}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content class="elevation-5 mb-3">
              <template v-slot:header>
                <div class="title">Detalhes da solicitação</div>
              </template>
              <v-card>
                <v-card-text class="px-4">
                  <v-layout row wrap>
                    <v-flex lg4 xs12
                      >Tipo de Solicitacao:
                      {{ protocoloDetalhe.tipoSolicitacao }}</v-flex
                    >
                    <v-flex lg4 xs12 v-if="isAssistencial"
                      >Urgência: {{ protocoloDetalhe.urgencia }}</v-flex
                    >
                    <v-flex lg4 xs12 v-if="isAssistencial"
                      >Data/Hora atendimento:
                      {{ protocoloDetalhe.dataAtendimento }}</v-flex
                    >
                  </v-layout>
                  <v-layout row wrap v-if="isAssistencial">
                    <v-flex lg12
                      >Procedimento solicitacao:
                      {{ protocoloDetalhe.categoria }} -
                      {{ protocoloDetalhe.motivo }} -
                      {{ protocoloDetalhe.subMotivo }}</v-flex
                    >
                  </v-layout>
                  <v-layout row wrap v-else>
                    <v-flex lg12
                      >Categoria: {{ protocoloDetalhe.categoria }} -
                      {{ protocoloDetalhe.motivo }} -
                      {{ protocoloDetalhe.subMotivo }}</v-flex
                    >
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg12 v-if="isAssistencial"
                      >Nome Prestador/Solicitante:
                      {{ protocoloDetalhe.prestador }}</v-flex
                    >
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content class="elevation-5 mb-3" v-if="hasGuias">
              <template v-slot:header>
                <div class="title">Guias</div>
              </template>
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex lg4 xs6>
                      <v-btn
                        flat
                        small
                        :class="printDarkMode ? 'black--text' : 'blue--text'"
                        @click="detalharGuia"
                        >{{ protocoloDetalhe.guia.numeroRequisicao }}</v-btn
                      >
                    </v-flex>
                    <v-flex lg4 xs6>
                      <v-chip
                        :color="guiaStatusColor"
                        :text-color="printDarkMode ? 'black' : 'white'"
                      >
                        {{ protocoloDetalhe.guia.statusGuia }}
                      </v-chip>
                    </v-flex>
                    <v-flex lg4 xs12 v-if="showBtn && hasCartaNegativa">
                      <v-btn
                        flat
                        small
                        class="green--text"
                        @click="baixarCartaNegativa"
                        >BAIXAR CARTA DE NEGATIVA</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content
              class="elevation-5 mb-3"
              v-if="hasTramites"
            >
              <template v-slot:header>
                <div class="title">Trâmites</div>
              </template>
              <v-card>
                <v-card-text class="px-4">
                  <v-layout
                    row
                    wrap
                    v-for="(tramite, index) in protocoloDetalhe.tramites"
                    :key="index"
                  >
                    <v-flex lg12 class="font-weight-bold">{{
                      tramite.dataHoraTramite
                    }}</v-flex>
                    <v-flex lg12>{{ tramite.descricaoTramite }}</v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-container>
    <loading-dialog :show="isLoading"></loading-dialog>
    <guia-detalhes
      :exibir-detalhe-guia="exibirDetalheGuia"
      :guia-detalhe="protocoloDetalhe.guia"
      @baixar-carta-negativa="baixarCartaNegativa"
      @fechar-modal="fecharModalGuia"
    ></guia-detalhes>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { download } from "@/utils/download";
import { baixarCartaNegativa, buscaProtocoloDetalhes } from "./service";

import LoadingDialog from "@/components/LoadingDialog";
import GuiaDetalhes from "./guia-detalhes";

const { mapState } = createNamespacedHelpers("beneficiario");
const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "ProtocoloDetalhe",
  components: {
    GuiaDetalhes,
    LoadingDialog
  },
  props: {
    numeroProtocolo: String
  },
  data() {
    return {
      exibirDetalheGuia: false,
      isLoading: false,
      panel: [true, true, true, true],
      printDarkMode: false,
      protocoloDetalhe: {},
      showBtn: true
    };
  },
  computed: {
    ...mapState(["dadosBeneficiario"]),
    codigoBeneficiario() {
      return this.dadosBeneficiario.id;
    },
    guiaStatusColor() {
      if (this.printDarkMode) {
        return "white";
      } else {
        if (this.protocoloDetalhe.guia?.statusGuia === "Aprovada") {
          return "green";
        } else if (this.protocoloDetalhe.guia?.statusGuia === "Negada") {
          return "red";
        } else if (
          this.protocoloDetalhe.guia?.statusGuia === "Aprovada parcial"
        ) {
          return "orange";
        } else {
          return "yellow";
        }
      }
    },
    isAssistencial() {
      return this.protocoloDetalhe.tipoSolicitacao === "Assistencial";
    },
    hasCartaNegativa() {
      return this.protocoloDetalhe.guia?.cartaNegativa?.permiteDownload;
    },
    hasGuias() {
      return this.protocoloDetalhe.guia !== null;
    },
    hasTramites() {
      return this.protocoloDetalhe.tramites?.length;
    }
  },
  created() {
    this.isLoading = true;
    this.protocoloDetalhes();
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    baixarCartaNegativa() {
      this.isLoading = true;

      const payload = {
        codigoBeneficiario: this.codigoBeneficiario,
        numeroGuia: this.protocoloDetalhe.numeroGuia
      };

      baixarCartaNegativa(payload)
        .then(({ headers, data }) => {
          const filename = headers["content-disposition"].replace(
            "attachment; filename=",
            ""
          );

          download(data, filename);
        })
        .catch(({ response }) => {
          if (response?.data?.error) {
            const errorMessage = response?.data?.message;

            this.setToast(errorMessage);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    baixarDetalhesProtocolo() {
      this.isLoading = true;
      this.showBtn = false;
      this.printDarkMode = true;

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4"
      });

      global.setTimeout(() => {
        html2canvas(document.querySelector("#protocolo"), { scale: 2 })
          .then(canvas => {
            const margin = 5;

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pageWidth - 2 * margin;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            const imgData = canvas.toDataURL("image/png");

            if (imgHeight + margin > pageHeight) {
              let heightLeft = imgHeight;
              let currentTop = margin;

              while (heightLeft > 0) {
                pdf.addImage(
                  imgData,
                  "PNG",
                  margin,
                  currentTop,
                  imgWidth,
                  imgHeight
                );

                heightLeft -= pageHeight - 2 * margin;

                if (heightLeft > 0) {
                  pdf.addPage();
                  currentTop -= pageHeight;
                }
              }
            } else {
              pdf.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);
            }

            pdf.save("protocolo-detalhes.pdf");
          })
          .finally(() => {
            this.isLoading = false;
            this.showBtn = true;
            this.printDarkMode = false;
          });
      }, 200);
    },
    detalharGuia() {
      this.exibirDetalheGuia = true;
    },
    fecharModalGuia() {
      this.exibirDetalheGuia = false;
    },
    async protocoloDetalhes() {
      this.isLoading = true;

      const payload = {
        codigoBeneficiario: this.codigoBeneficiario,
        numeroProtocolo: this.numeroProtocolo
      };

      await buscaProtocoloDetalhes(payload)
        .then(({ data }) => (this.protocoloDetalhe = data))
        .catch(({ response }) => {
          if (response?.data?.error) {
            const errorMessage = response?.data?.message;

            this.setToast(errorMessage);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    voltar() {
      this.$emit("voltar");
    }
  }
};
</script>
